export function confirmPopup() {
    $(".confirm-popup-opener").on("click", function (event) {
        event.preventDefault();
        $("#confirm-popup").addClass("show");
    });
    $(".confirm-popup-close").on("click", function (event) {
        event.preventDefault();
        $("#confirm-popup").removeClass("show");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/confirmPopup.js